<fieldset>
  <legend id="step4_getspan4">{{ step4.getspan4 | translate }}</legend>

  <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''" [label]="step4.getunlot"
    [type]="'checkbox'" [checkboxDestination]="'string'" [rule]="'pattern_29'" [isChecked]="lots?.unLot" [name]="getUid()+'_SepAtt_unLot'">
  </app-form-input>

  <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''"
    [label]="step4.getplusieurslot" [type]="'checkbox'" [checkboxDestination]="'string'" [rule]="'pattern_29'" [isChecked]="lots?.plusieursLot"
    [name]="getUid()+'_SepAtt_plusieursLot'">
  </app-form-input>

  <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''" [label]="step4.gettouslots"
    [type]="'checkbox'" [checkboxDestination]="'string'" [rule]="'pattern_29'" [isChecked]="lots?.tousLots" [name]="getUid()+'_SepAtt_tousLots'">
  </app-form-input>
</fieldset>


<fieldset>
  <legend id="step4_section1">{{ step4.section1 | translate }}</legend>

  <button class="btn btn-outline-primary" (click)="addlot()">{{ step4.add | translate }}</button>
  <div *ngFor="let obj of lots?.lot; let i = index">
    <button class="btn btn-outline-primary" (click)="removelot(i)">{{ step4.remove | translate }}</button>
    <app-lot [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [disabled]="disabled" [nbIteration]="i"
      [lot]="obj"></app-lot>
  </div>

</fieldset>
